const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

/**
 * Resolves a relative object-storage path to a full URL and requests WebP
 * delivery for Unsplash-hosted images (smaller payloads, faster LCP).
 */
export function resolveImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("data:")) return url;
  if (url.startsWith("http")) return optimizeRemote(url);
  return `${BACKEND}${url}`;
}

function optimizeRemote(url) {
  if (!url.includes("images.unsplash.com")) return url;
  if (url.includes("fm=webp")) return url;
  if (url.includes("fm=jpg")) return url.replace("fm=jpg", "fm=webp");
  return url + (url.includes("?") ? "&" : "?") + "fm=webp";
}
